import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const classes = {
  root: css`
    max-block-size: ${spacing(50)};
    max-inline-size: ${spacing(60.75)};
    inline-size: 100%;
  `,
  header: css`
    border-radius: ${spacing(3)};
    background-color: ${cssTheme.default.day.background};
    position: relative;
    z-index: 10;
  `,
  body: css`
    padding-inline: 0;
  `,
  cityInput: css`
    margin-block-start: ${spacing(2)};
    margin-block-end: ${spacing(1)};
    inline-size: 100%;
  `,
  listRoot: css`
    block-size: 100%;
    display: grid;
    grid-template-rows: 1fr 1fr;
  `,
  listItem: css`
    align-items: center;
    border-bottom: 1px solid ${cssTheme.default.day.backgroundMinor};
    cursor: pointer;
    display: flex;
    padding-block: ${spacing(1.5)};
    padding-inline: ${spacing(2)};

    @media (hover: hover) {
      &:hover {
        background-color: ${cssTheme.default.day.backgroundMinor};
      }
    }
  `,
  selectedItem: css`
    background-color: ${cssTheme.default.day.backgroundMinor};
  `,
  footer: css`
    background-color: ${cssTheme.default.day.background};
    border-radius: ${spacing(3)};
    position: relative;
    z-index: 10;
  `,
  title: css`
    margin-block-end: ${spacing(2)};
  `,
}
